export default {
    buyBack: 'Rachat',
    refinance: 'Refinancer',
    renewal: '@.capitalize:lexicon.renewed.infinitive',
    refuseToRenew: 'Refuse de @:lexicon.renewed.infinitive',
    return: 'Retour',
};
